import { Operation } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';

const DO_NOT_RETRY_STATUS_CODES = [400];

export const shouldRetry = (
  error: { statusCode?: number } | null | undefined,
  operation: Operation
) => {
  if (operation.getContext().skipRetry) return false;
  return !!error && !DO_NOT_RETRY_STATUS_CODES.includes(error.statusCode ?? 0);
};

export const createRetryLink = () =>
  new RetryLink({
    delay: {
      initial: 500,
      max: 3,
    },
    attempts: {
      max: 3,
      retryIf: shouldRetry,
    },
  });
